import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { TableVariant } from '@constants/common/ui.constants';

const useStyles = makeStyles<{ variant: TableVariant }>()(
  (theme, { variant }) => ({
    tableWrapper: {
      ...dFlex('flex-start'),
      borderRadius: theme.borderRadius.md,
      paddingBottom: 16,
      overflow: 'auto',
      width: '100%',

      ...(variant === TableVariant.Contained && {
        background: theme.background.b2,
      }),

      ...(variant === TableVariant.Secondary && {
        background: theme.secondary.s5,
      }),
    },
    scrollableTableContainer: {
      width: '100%',
      height: '100%',
      overflowY: 'auto',
      overflowX: 'auto',
      position: 'relative',
      WebkitOverflowScrolling: 'touch',

      '&::-webkit-scrollbar-corner': {
        background: 'transparent',
      },

      '&::-webkit-scrollbar-track': {
        background: theme.primary.p3,
      },

      '&::-webkit-scrollbar-thumb': {
        background: theme.primary.p3,
      },

      /* Firefox Scrollbar Styling */
      scrollbarWidth: 'thin', // For Firefox
      scrollbarColor: `${theme.primary.p3} transparent`, // For Firefox
    },
    table: {
      display: 'grid',
      borderCollapse: 'collapse',
      borderSpacing: 0,
      // tableLayout: 'fixed',

      tableLayout: 'auto', // Allow dynamic sizing
      minWidth: '100%', // Ensure the table can scroll horizontally if necessary

      tbody: {
        display: 'grid',
        position: 'relative',
      },
    },
    header: {
      display: 'grid',
      width: '100%',
      position: 'sticky',
      top: -1,
      zIndex: 2,
      paddingTop: 16,
      paddingBottom: 8,

      ...(variant === TableVariant.Contained && {
        background: theme.background.b2,
      }),

      ...(variant === TableVariant.Secondary && {
        background: theme.secondary.s5,
      }),

      tr: {
        paddingLeft: 16,
        paddingRight: 16,
        display: 'flex',
      },
    },
    headerTh: {
      ...dFlex('flex-start'),
      width: '100%',
    },
    tableRow: {
      ...dFlex('flex-start', 'center'),
      paddingLeft: 16,
      paddingRight: 16,
      position: 'absolute',
      width: '100%',

      ...(variant === TableVariant.Contained && {
        '&:hover': {
          backgroundColor: theme.secondary.s6,

          td: {
            backgroundColor: `${theme.secondary.s6} !important`,
          },
        },
      }),

      ...(variant === TableVariant.Secondary && {
        '&:hover': {
          backgroundColor: theme.secondary.s6,

          td: {
            backgroundColor: `${theme.secondary.s6} !important`,
          },
        },
      }),
    },
    loaderCell: {
      ...dFlex(),
      height: '100%',
      width: '100%',
    },
    noDataCell: {
      ...dFlex(),
      height: '100%',
      width: '100%',
      color: theme.primary.p2,
    },
    headerCellSorted: {
      ...dFlex(),
      gap: 4,
      cursor: 'pointer',
    },
  }),
);

export default useStyles;
